module.exports = __webpack_public_path__ + "img/background4.00559c42.png";